import { Facebook, Linkedin, Instagram, Twitter } from "lucide-react";

const socialLinks = [
  {
    name: "Facebook",
    href: "https://www.facebook.com/profile.php?id=61585639141987",
    icon: Facebook,
    hoverColor: "hover:bg-[#1877F2] hover:text-white",
  },
  {
    name: "LinkedIn",
    href: "https://www.linkedin.com/company/refertle/",
    icon: Linkedin,
    hoverColor: "hover:bg-[#0A66C2] hover:text-white",
  },
  {
    name: "Instagram",
    href: "https://www.instagram.com/refertle_/",
    icon: Instagram,
    hoverColor: "hover:bg-gradient-to-br hover:from-[#833AB4] hover:via-[#FD1D1D] hover:to-[#F77737] hover:text-white",
  },
  {
    name: "X",
    href: "https://x.com/refertle",
    icon: Twitter,
    hoverColor: "hover:bg-black hover:text-white",
  },
];

export function FloatingSocialSidebar() {
  return (
    <>
      {/* Desktop: Left side vertical bar */}
      <div className="fixed left-0 top-1/2 -translate-y-1/2 z-40 hidden md:flex flex-col gap-1 p-1.5 bg-card/80 backdrop-blur-sm border border-border rounded-r-xl shadow-lg">
        {socialLinks.map((social) => (
          <a
            key={social.name}
            href={social.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={social.name}
            className={`p-2.5 rounded-lg text-muted-foreground transition-all duration-300 ${social.hoverColor} hover:scale-110 hover:shadow-md`}
          >
            <social.icon className="w-4 h-4" />
          </a>
        ))}
      </div>

      {/* Mobile: Bottom horizontal bar */}
      <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40 flex md:hidden flex-row gap-2 p-2 bg-card/90 backdrop-blur-md border border-border rounded-full shadow-lg">
        {socialLinks.map((social) => (
          <a
            key={social.name}
            href={social.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={social.name}
            className={`p-3 rounded-full text-muted-foreground transition-all duration-300 ${social.hoverColor} active:scale-95`}
          >
            <social.icon className="w-5 h-5" />
          </a>
        ))}
      </div>
    </>
  );
}
